import { telInput } from '../components/telInput';
import { dobInput } from '../components/dobInput';
import { runAtreemoFunctions } from './atreemo';
const iti = telInput();
const datepicker = dobInput();
const signupFormElem = document.getElementById('newsletter-signup-form');

export const newsletterSignupFunctionality = () => {
    const submitButton = document.querySelector('.js-newsletter-signup-trigger');

    if ( submitButton ) {
        submitButton.addEventListener('click', (event) => {
            event.preventDefault();

            // Validate the form
            if (signupFormElem.checkValidity()) {
                // If form is valid, dispatch the submit event
                const submitEvent = new Event('submit', {
                    bubbles: true,
                    cancelable: true
                });
                signupFormElem.dispatchEvent(submitEvent);
            } else {
                // If form is invalid, trigger browser's default validation UI
                signupFormElem.reportValidity();
            }
        });
    }

    signupFormElem.addEventListener('submit', (e) => {
        e.preventDefault();

        const popup = signupFormElem.closest('.popup-newsletter');
        const formContainer = popup.querySelector('.popup-newsletter__form-container');
        
        // Remove any existing errors
        formContainer.querySelector('.popup-newsletter__phone-number-error').classList.add('hidden');
        formContainer.querySelector('.popup-newsletter__location-error').classList.add('hidden');
        // Show the loader
        signupFormElem.classList.add('opacity-30');
        formContainer.querySelector('.js-popup-loader').classList.remove('hidden');

        // Check if the phone number and location are valid
        if ( !iti.isValidNumber() || document.getElementById('signup_local_wasabi').value === '' ) {
            setTimeout(() => {
                if ( !iti.isValidNumber() ) {
                    formContainer.querySelector('.popup-newsletter__phone-number-error').classList.remove('hidden');
                }

                if ( document.getElementById('signup_local_wasabi').value === '' ) {
                    formContainer.querySelector('.popup-newsletter__location-error').classList.remove('hidden');
                }

                signupFormElem.classList.remove('opacity-30');
                formContainer.querySelector('.js-popup-loader').classList.add('hidden');
            }, 400);

            return;
        }

        // Store the ajax data
        const ajaxData = {
            brandId: document.getElementById('signup_BrandID').value,
            source: document.getElementById('signup_SourceID').value,
            email: document.getElementById('signup_email').value,
            location: document.getElementById('signup_local_wasabi').value,
            firstName: document.getElementById('signup_first_name').value,
            surname: document.getElementById('signup_last_name').value,
            phone: iti.getNumber(),
            dob: datepicker.getDate().toISOString,
            optInDate: new Date().toISOString(),
            emailOptIn: document.getElementById('signup_email_optin').checked ? 'yes' : 'no',
            smsOptIn: document.getElementById('signup_sms_optin').checked ? 'yes' : 'no',
            action: 'ajax_atreemo'
        };

        // Run the atreemo functions
        runAtreemoFunctions(ajaxData).then((response) => {
            // Update the response elements
            const responseContainer = popup.querySelector('.js-response-container');
            const responseHeading = responseContainer.querySelector('.js-response-heading');
            const responseContent = responseContainer.querySelector('.js-response-content');

            responseHeading.textContent = response.heading;
            responseContent.innerHTML = response.content;

            // Hide the form
            formContainer.classList.add('hidden');
            popup.querySelector('.popup-newsletter__title').classList.add('hidden');
            popup.querySelector('.popup-newsletter__col').classList.remove('hidden');

            setTimeout(() => {
                responseContainer.classList.remove('hidden');
            }, 1000);
        });
    });
}